import { num, toggle, type Choice } from '../../themes/settingFields';
import { named } from '../../themes/settingFields';
import { element } from './definition';
import { look } from './styleTokens';

// A ticker: its children slide past endlessly, which is the announcement bar every reference opens
// with. The settings are Shopify's own Scrolling promotion, name for name — direction, pause on hover,
// speed, the space between items — because those four are the whole of what a merchant ever changes.
//
// The seamless loop is the element's job and never the merchant's. The old bar carried two hand-made
// copies of its line so the track could snap back unnoticed; editing one copy broke the illusion, and
// a merchant has no way of knowing the second copy exists. Here the element repeats its own children.

/** Which way the line travels, in the words Shopify uses; mirrored automatically for an RTL theme. */
const DIRECTIONS: readonly Choice[] = [['start', 'Towards the start'], ['end', 'Towards the end']];

/** Speed in pixels a second. The reference runs at about 74; under 20 reads as stuck, over 300 as broken. */
const MIN_SPEED = 20;
const MAX_SPEED = 300;

/** The space between items. The reference uses 60px; a merchant may want it tighter or airier. */
const MIN_SPACING = 0;
const MAX_SPACING = 200;

/** The ticker: a strip whose children slide past, and come round again, for as long as it is on screen. */
export const marqueeElement = element('marquee', {
  label: 'Ticker',
  description: 'A strip whose items slide past endlessly — the promises an announcement bar scrolls.',
  category: 'Layouts',
  icon: 'gallery-horizontal-end',
  props: [
    named('direction', 'Direction', DIRECTIONS),
    toggle('pauseOnHover', 'Pause scroll on hover'),
    { ...num('speed', 'Speed', MIN_SPEED, MAX_SPEED), help: 'Pixels a second. Stops for anyone who asked for less motion.' },
    { ...num('spacing', 'Horizontal spacing', MIN_SPACING, MAX_SPACING), help: 'Pixels between one item and the next.' }
  ],
  defaults: {
    props: { direction: 'start', pauseOnHover: false, speed: 74, spacing: 60 },
    styles: look({ display: 'block', width: '100%', overflow: 'hidden' })
  },
});
